import get from 'lodash/get';
import { connect } from 'react-redux';
import { compose, withProps } from 'recompose';

import { VIRTUAL_VISIT_EVENTS } from '../../../constants';
import { selectCurrentAppointment } from '../../../redux/appointmnents/selectors';
import { appointmentDetailsActions } from '../../../redux/healthboard/appointment-details';

const mapStateToProps = state => ({
  appointment: selectCurrentAppointment(state),
});

const mapDispatchToProps = {
  changeStatus: appointmentDetailsActions.changeStatus,
};

export const enhance = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withProps(({ appointment, changeStatus }) => ({
    handleStartVisit: () =>
      changeStatus({
        appointment,
        id: get(appointment, 'userId'),
        event: VIRTUAL_VISIT_EVENTS.START_VISIT,
        flow: 'get-care',
      }),
  })),
);



// WEBPACK FOOTER //
// ./src/components/AppointmentForm/AppointmentSummary/enhance.js